import React from "react";

const HouseOfTraders = () => {
  return (
    <div className="w-full h-screen fixed top-0 left-0">
      <div className="h-full  w-full relative">
        <video
          className="w-full h-full object-cover top-0  absolute"
          src="/logo-motions/house-of-traders.mp4"
          autoPlay
          muted
          playsInline
        />
      </div>
    </div>
  );
};

export default HouseOfTraders;
